import { useCallback, useMemo, useState } from "react"

export const useTransition = () => {
  const [actions, setActions] = useState(0)
  const isPending = useMemo(() => actions > 0, [actions])

  const startTransition = useCallback((action) => {
    setActions(prevActions => prevActions+1)
    Promise.resolve()
      .then(() => typeof action === 'function' ? action() : action)
      .finally(() => setActions(prevActions => Math.max(0, prevActions-1)))
  }, [])

  return [isPending, startTransition]
}
